module.exports = __webpack_public_path__ + "static/img/default_avatar.935c5c18.png";